import { defineNuxtPlugin, onNuxtReady } from '#imports'
// INP yield pattern inspired by Core Web Vitals guidance:
// https://www.corewebvitals.io/pagespeed/datalayer-inp-yield-pattern

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  onNuxtReady(() => {
    async function awaitPaint(fn: () => void) {
      await new Promise((resolve) => {
        setTimeout(resolve, 200)
        requestAnimationFrame(() => {
          setTimeout(resolve, 50)
        })
      })

      if (typeof fn === 'function') {
        fn()
      }
    }

    // --------------------------
    // Patch Google Tag Manager's dataLayer.push
    // --------------------------
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      const originalDataLayerPush = window.dataLayer.push.bind(window.dataLayer)
      // @ts-expect-error TS types expect push to return number, but we need async
      window.dataLayer.push = (event: DataLayerEvent) => {
        ;(async () => {
          await awaitPaint(() => {
            if (event['gtm.element']) {
              // eslint-disable-next-line no-param-reassign
              event['gtm.element'] = event['gtm.element'].cloneNode(true)
            }
            originalDataLayerPush(event)
          })
        })()
      }
    }

    // --------------------------
    // Patch Google Analytics gtag function
    // --------------------------
    if (window.gtag && typeof window.gtag === 'function') {
      const originalGtag = window.gtag.bind(window)

      window.gtag = (...args) => {
        ;(async () => {
          await awaitPaint(() => {
            originalGtag(...args)
          })
        })()
      }
    }
  })
})
